import posthog from 'posthog-js';
import { UserTypeEnum } from '@/app/types/user-type.ts';

const projectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const apiHost = 'https://us.i.posthog.com';

export const isPostHogConfigured = Boolean(projectToken);

if (isPostHogConfigured) {
  posthog.init(projectToken, {
    api_host: apiHost,
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: import.meta.env.MODE === 'development',
    session_recording: {
      maskAllInputs: true,
    },
  });

  posthog.register({
    app_surface: 'web',
    environment: import.meta.env.MODE,
  });
}

export function userTypeLabel(userType: UserTypeEnum): string {
  switch (userType) {
    case UserTypeEnum.DrugRep:
      return 'drug_rep';
    case UserTypeEnum.StaffMember:
      return 'staff_member';
    case UserTypeEnum.Admin:
      return 'admin';
    default:
      return 'unknown';
  }
}

export { posthog };
